// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"8afef12a","453":"af47d455","755":"c36129cc","911":"320d3642","949":"8a976fe8"}[chunkId] + ".chunk.js";
};